import store from "../../../../../../../../store";
import sqftEventManager from "../../../../store/sqftEventManager";
import {
  getMidPoint,
  getMousePositionOnField,
  getPointDistance,
  getPointField
} from "../../../../../../helpers/sqftHelper";
import COLOR_THEMES from "../../../../store/colorThemes";
import sqftConfig from "../../../../store/sqftConfig";
import NumberText from "../../../workspace/text/numberText";
import workspace from "../../../workspace";
import {
  getClosestIntersectionPoints,
  getIntersectionPointsAndLines,
} from "./seamToolHelper";
import ShapeHelper from "../../../../../../helpers/shapeHelper";
import RenderFigures from "../../../../helpers/renderFigures";
import config from "../../../../store/sqftConfig";

class SeamToolRender {
  __measurement1 = new NumberText(0, {}, {}, workspace, Function(), false);
  __measurement2 = new NumberText(0, {}, {}, workspace, Function(), false);
  seamTool;
  absoluteLinePoint1Pos = {};
  absoluteLinePoint2Pos = {};

  constructor(seamTool) {
    this.seamTool = seamTool;
  }

  renderSeamHorizontalIntersection = (ctx) => {
    const serverState = store.getState().serverState;
    const mousePos = sqftEventManager.getMousePos();
    const mousePosOnFiled = getMousePositionOnField(mousePos.x, mousePos.y);
    const pos = this.seamTool.__shape.getPosition();
    const mousePosOnShape = {x: mousePosOnFiled.x - pos.x, y: mousePosOnFiled.y - pos.y};
    this.absoluteLinePoint1Pos = null; //reset minLength for correct calculations without stacking
    this.absoluteLinePoint2Pos = null; //reset minLength for correct calculations without stacking

    // vertical line
    let verticalLinePoint1 = {x: -serverState.windowWidth, y: mousePosOnShape.y};
    let verticalLinePoint2 = {x: serverState.windowWidth, y: mousePosOnShape.y};
    let distancesToLines = ShapeHelper.getDistancesToPoint(mousePos);
    let snappingPossibilitiesToLines = ShapeHelper.getSnappingPossibilitiesToLines(distancesToLines);
    if (snappingPossibilitiesToLines.length > 0) {
      //console.log("distancesToLines", distancesToLines);
      //console.log("getSnappingPossibilitiesToLines", snappingPossibilitiesToLines);
      this.setAbsolutePosFromSnapPossibilities(snappingPossibilitiesToLines, verticalLinePoint1, verticalLinePoint2);
      verticalLinePoint1 = this.absoluteLinePoint1Pos;
      verticalLinePoint2 = this.absoluteLinePoint2Pos;
    }
    this.renderSeamDashedLine(ctx, verticalLinePoint1, verticalLinePoint2);

    // horizontal line
    let horizontalLinePoint1 = {x: mousePosOnShape.x , y: -serverState.windowHeight};
    let horizontalLinePoint2 = {x: mousePosOnShape.x, y: serverState.windowHeight};
    if (snappingPossibilitiesToLines.length > 0) {
      mousePosOnShape.y = this.absoluteLinePoint1Pos.y
    }
    this.renderSeamArrowLine(ctx, horizontalLinePoint1, horizontalLinePoint2, mousePos, mousePosOnShape);
  }

  renderSeamVerticalIntersection = (ctx) => {
    const serverState = store.getState().serverState;
    const mousePos = sqftEventManager.getMousePos();
    const mousePosOnFiled = getMousePositionOnField(mousePos.x, mousePos.y);
    const pos = this.seamTool.__shape.getPosition();
    const mousePosOnShape = {x: mousePosOnFiled.x - pos.x, y: mousePosOnFiled.y - pos.y};
    this.absoluteLinePoint1Pos = null; //reset minLength for correct calculations without stacking
    this.absoluteLinePoint2Pos = null; //reset minLength for correct calculations without stacking

    // vertical line
    let verticalLinePoint1 = {x: mousePosOnShape.x, y: -serverState.windowHeight};
    let verticalLinePoint2 = {x: mousePosOnShape.x, y: serverState.windowHeight};
    let distancesToLines = ShapeHelper.getDistancesToPoint(mousePos);
    let snappingPossibilitiesToLines = ShapeHelper.getSnappingPossibilitiesToLines(distancesToLines);
    if (snappingPossibilitiesToLines.length > 0) {
      //console.log("distancesToLines", distancesToLines);
      //console.log("getSnappingPossibilitiesToLines", snappingPossibilitiesToLines);
      this.setAbsolutePosFromSnapPossibilities(snappingPossibilitiesToLines, verticalLinePoint1, verticalLinePoint2);
      verticalLinePoint1 = this.absoluteLinePoint1Pos;
      verticalLinePoint2 = this.absoluteLinePoint2Pos;
    }
    this.renderSeamDashedLine(ctx, verticalLinePoint1, verticalLinePoint2);

    // horizontal line
    let horizontalLinePoint1 = {x: -serverState.windowWidth , y: mousePosOnShape.y};
    let horizontalLinePoint2 = {x: serverState.windowWidth, y: mousePosOnShape.y};
    if (snappingPossibilitiesToLines.length > 0) {
      mousePosOnShape.x = this.absoluteLinePoint1Pos.x
    }
    this.renderSeamArrowLine(ctx, horizontalLinePoint1, horizontalLinePoint2, mousePos, mousePosOnShape);
  };

  setAbsolutePosFromSnapPossibilities = (snapPossibilities, verticalLinePoint1, verticalLinePoint2) => {
    if (snapPossibilities.length > 0) {
      let scale = sqftConfig.scale;
      let absoluteLinePoint1Pos = {...verticalLinePoint1};
      let absoluteLinePoint2Pos = {...verticalLinePoint2};
      snapPossibilities.forEach((snap) => {
        switch (snap.orientation) {
          case "horizontal":
            absoluteLinePoint1Pos.y -= snap.diff / scale
            absoluteLinePoint2Pos.y -= snap.diff / scale
            break;
          case "vertical":
            absoluteLinePoint1Pos.x -= snap.diff / scale
            absoluteLinePoint2Pos.x -= snap.diff / scale
            break;
        }
        this.absoluteLinePoint1Pos = absoluteLinePoint1Pos;
        this.absoluteLinePoint2Pos = absoluteLinePoint2Pos;
      })
    }
  }

  renderSeamDashedLine = (ctx, verticalLinePoint1, verticalLinePoint2) => {
    let [intersection1, intersection2] = getIntersectionPointsAndLines(
      this.seamTool.__shape.getLines(), verticalLinePoint1, verticalLinePoint2
    );
    ctx.strokeStyle = COLOR_THEMES[sqftConfig.activeTheme].primary;

    if (intersection1 && intersection2) {
      let intersectionYPoint1 = intersection1.intersectionCords;
      let intersectionYPoint2 = intersection2.intersectionCords;
      let intersectionYPoint1PointField = getPointField(intersectionYPoint1.x, intersectionYPoint1.y, this.seamTool.__shape);
      let intersectionYPoint2PointField = getPointField(intersectionYPoint2.x, intersectionYPoint2.y, this.seamTool.__shape);
      ctx.beginPath();
      ctx.setLineDash([10, 10]);
      ctx.moveTo(intersectionYPoint1PointField.x , intersectionYPoint1PointField.y);
      ctx.lineTo(intersectionYPoint2PointField.x, intersectionYPoint2PointField.y);
      ctx.closePath();
      ctx.stroke();
      ctx.setLineDash([0]);
    }
  }

  renderSeamArrowLine = (ctx, horizontalLinePoint1, horizontalLinePoint2, mousePos, mousePosOnShape) => {
    let mousePosOnShapePointField = getPointField(mousePosOnShape.x, mousePosOnShape.y, this.seamTool.__shape);
    let [intersectionXPointAndLine1, intersectionXPointAndLine2] = getClosestIntersectionPoints(
      this.seamTool.__shape.getLines(), horizontalLinePoint1, horizontalLinePoint2, mousePosOnShape
    );

    if (intersectionXPointAndLine1 && intersectionXPointAndLine2) {
      let intersectionXPoint1 = intersectionXPointAndLine1.intersectionCords;
      let intersectionXPoint2 = intersectionXPointAndLine2.intersectionCords;
      let intersectionXPoint1PointField = getPointField(intersectionXPoint1.x, intersectionXPoint1.y, this.seamTool.__shape);
      let intersectionXPoint2PointField = getPointField(intersectionXPoint2.x, intersectionXPoint2.y, this.seamTool.__shape);
      ctx.beginPath();
      RenderFigures.drawArrow(ctx,
        intersectionXPoint1PointField.x,
        intersectionXPoint1PointField.y,
        mousePosOnShapePointField.x,
        mousePosOnShapePointField.y
      );
      let measurement1Midpoint = getMidPoint(mousePosOnShapePointField, intersectionXPoint1PointField);
      let measurement1Distance = getPointDistance(intersectionXPoint1, mousePosOnShape);
      RenderFigures.drawArrow(ctx,
        mousePosOnShapePointField.x,
        mousePosOnShapePointField.y,
        intersectionXPoint2PointField.x,
        intersectionXPoint2PointField.y
      );
      let measurement2Midpoint = getMidPoint(mousePosOnShapePointField, intersectionXPoint2PointField);
      let measurement2Distance = getPointDistance(intersectionXPoint2, mousePosOnShape);
      ctx.closePath();
      ctx.stroke();

      this.renderMeasurements(ctx, measurement1Midpoint, measurement1Distance, measurement2Midpoint, measurement2Distance)
    }
  }

  renderMeasurements = (ctx, measurement1Midpoint, measurement1Distance, measurement2Midpoint, measurement2Distance) => {
    let measurement1Pos = getMousePositionOnField(measurement1Midpoint.x, measurement1Midpoint.y);
    let measurement2Pos = getMousePositionOnField(measurement2Midpoint.x, measurement2Midpoint.y);

    this.__measurement1.pos.x = measurement1Pos.x;
    this.__measurement1.pos.y = measurement1Pos.y;
    this.__measurement1.value = Math.round(config.getMeasureMultiplier() * measurement1Distance);

    this.__measurement2.pos.x = measurement2Pos.x;
    this.__measurement2.pos.y = measurement2Pos.y;
    this.__measurement2.value = Math.round(config.getMeasureMultiplier() * measurement2Distance);

    this.__measurement1.render(ctx);
    this.__measurement2.render(ctx);
  }
}

export default SeamToolRender
